import { useCallback, useEffect, useRef, useState } from 'react'
import DashboardLogsActionsByModule from '../../../commom/AnaCharts/DashboardLogsActionsByModule'
import DashboardLogsActionsByUser from '../../../commom/AnaCharts/DashboardLogsActionsByUser'
import DashboardLogsActionsByDay from '../../../commom/AnaCharts/DashboardLogsActionsByDay'
import DashboardLogsActionsByTime from '../../../commom/AnaCharts/DashboardLogsActionsByTime'

import { getLogsAuditSummary } from '../../../../services/audit/audit.service'
import { useSelector } from 'react-redux'
import BoxChart from '../../../section/BoxChart'

const CHARTS = [
  { id: 'module', title: 'What is the action count by module?', chartID: 'logs-actions-by-module' },
  { id: 'user', title: 'Who performs actions more often?', chartID: 'logs-actions-by-user' },
  { id: 'day', title: 'What is the total action count by day?', chartID: 'logs-actions-by-day' },
  { id: 'time', title: 'What is the total action count by time?', chartID: 'logs-actions-by-time' }
]

const Dashboard = () => {
  const [datasets, setDatasets] = useState({ byModule: [], byUser: [], byDay: [], byTime: [] })
  const [loading, toggleLoading] = useState(true)
  const [expanded, setExpanded] = useState(null) // chart id or null
  const state = useSelector((state) => state?.filter?.audit)

  const debounceRef = useRef(null)

  const loadData = useCallback(() => {
    clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(async () => {
      try {
        toggleLoading(true)
        const filter = {
          ...state?.filter,
          module: state?.filter?.module?.value,
          action: state?.filter?.action?.value
        }
        const result = await getLogsAuditSummary(filter)
        toggleLoading(false)
        setDatasets(result?.data || { byModule: [], byUser: [], byDay: [], byTime: [] })
      } catch (error) {
        toggleLoading(false)
      }
    }, 120)
  }, [state])

  useEffect(() => {
    loadData()
    return () => clearTimeout(debounceRef.current)
  }, [loadData])

  const toggle = (id) => setExpanded((prev) => (prev === id ? null : id))

  const renderChart = (id, chartID, dataSet) => {
    if (id === 'module') return <DashboardLogsActionsByModule chartID={chartID} dataSet={dataSet} />
    if (id === 'user') return <DashboardLogsActionsByUser chartID={chartID} dataSet={dataSet} />
    if (id === 'day') return <DashboardLogsActionsByDay chartID={chartID} dataSet={dataSet} />
    if (id === 'time') return <DashboardLogsActionsByTime chartID={chartID} dataSet={dataSet} />
    return null
  }

  const dataFor = (id) =>
    ({
      module: { byModule: datasets.byModule || [] },
      user: { byUser: datasets.byUser || [] },
      day: { byDay: datasets.byDay || [] },
      time: { byTime: datasets.byTime || [] }
    })[id]

  if (expanded) {
    const chart = CHARTS.find((c) => c.id === expanded)
    return (
      <div className='h-full'>
        <BoxChart
          title={chart.title}
          loading={loading}
          expandable
          expanded
          onToggleExpand={() => toggle(expanded)}
        >
          {renderChart(chart.id, chart.chartID, dataFor(chart.id))}
        </BoxChart>
      </div>
    )
  }

  return (
    <div className='grid grid-cols-2 gap-4 h-full'>
      {CHARTS.map(({ id, title, chartID }) => (
        <BoxChart
          key={id}
          title={title}
          loading={loading}
          expandable
          expanded={false}
          onToggleExpand={() => toggle(id)}
        >
          {renderChart(id, chartID, dataFor(id))}
        </BoxChart>
      ))}
    </div>
  )
}

export default Dashboard
